module.exports = "pegasus_template/assets/blocks/tile-layout-08.png";